import type { GlobalState } from "@/types/globalState";
import type { MenuItem } from "@/types/menuItem";
import { getGlobalContentitem } from "@/helpers/contentHelpers";
import parse from "html-react-parser";

export const topMenuItems = [
    { to: "/", code: "AcademyHome", fallback: "Home" },
    { to: "/programs", code: "MijnLeerprogramma", fallback: "Mijn Leerprogramma" },
    { to: "/manager", code: "ManagerBeheer", fallback: "Manager" },
    { to: "/admin/programs", code: "AcademyBeheer", fallback: "Beheer" },
    { to: "/about", code: "OverMalenco", fallback: "Over Malenco" },
    { to: "/contact", code: "Contact", fallback: "Contact" }
] as const satisfies readonly MenuItem[];

export const bottomMenuItems = [
    { to: "/beveiligingsbeleid", code: "Beveiligingsbeleid", fallback: "Beveiligingsbeleid" },
    { to: "/cookiebeleid", code: "Cookiebeleid", fallback: "Cookiebeleid" }
] as const satisfies readonly MenuItem[];

export const adminMenuItems = [
    { to: "/", code: "AcademyHome", fallback: "Home" },
] as const satisfies readonly MenuItem[];

export const heroMenuItems = [
    { to: "/request", code: "StartNu", fallback: "Start Nu" },
    { to: "/programs", code: "MijnLeerprogramma", fallback: "Mijn Leerprogramma" },
    { to: "/courses", code: "AcademyProgrammas", fallback: "Programma's" },
    { to: "/manager", code: "ManagerBeheer", fallback: "Manager" },
    { to: "/admin/programs", code: "AcademyBeheer", fallback: "Beheer" },
] as const satisfies readonly MenuItem[];

export const renderMenuLabel = (code: string, fallback: string, globalState: GlobalState) => {
    const item = getGlobalContentitem(code, globalState);
    if (!item) return fallback;
    return parse(item.title);
};
